import { connect } from "react-redux";

import Router from "./Router";

// -----------------------------------------------------------------------------

const App = connect(
  () => ({}),
  {}
)(function App() {
  return <Router />;
});

// -----------------------------------------------------------------------------

export default App;
